import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../lib/api-client';
import type { Advisor, CreateAdvisorInput } from '../../../types/admin';
import { useClaveInmobiliaria } from '../inmobiliaria-activa/inmobiliaria-activa';

export function useAdvisors() {
  const inmobiliaria = useClaveInmobiliaria();
  return useQuery<Advisor[]>({
    queryKey: ['advisors', inmobiliaria],
    queryFn: () => apiClient.users.advisors.list(),
  });
}

function invalidate(queryClient: ReturnType<typeof useQueryClient>): void {
  void queryClient.invalidateQueries({ queryKey: ['advisors'] });
}

export function useCreateAdvisor() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAdvisorInput) => apiClient.users.advisors.create(data),
    onSuccess: () => invalidate(queryClient),
  });
}

export function useAssignProjects() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, proyectoIds }: { id: string; proyectoIds: string[] }) =>
      apiClient.users.advisors.assignProjects(id, proyectoIds),
    onSuccess: () => invalidate(queryClient),
  });
}

export function useResendInvitation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.users.advisors.resendInvitation(id),
    onSuccess: () => invalidate(queryClient),
  });
}

export function useToggleAdvisor() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, activo }: { id: string; activo: boolean }) =>
      activo ? apiClient.users.advisors.activate(id) : apiClient.users.advisors.deactivate(id),
    onSuccess: () => invalidate(queryClient),
  });
}
